import { createStyles, Theme } from '@material-ui/core';

export const styles = (theme: Theme) =>
  createStyles({
    dialogActionsRoot: {
      margin: '14px'
    },
    root: {
      flexGrow: 1
      // backgroundColor: theme.palette.background.paper,
      // minHeight: '100vh',
      // '& *:focus': {
      //   outline: 'none !important'
      // }
    }
  });
